import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';

import arrowIcon from "../../assets/return_icon_blk.svg"
const useStyles = makeStyles({
    root: {
        width: "100%",
        padding: "43px 56px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "space-between"
    },
    back: {
        fontSize: "28px",
        cursor: "pointer"
    },
    close: {
        fontSize: "28px",
        cursor: "pointer"
    },
    invisible: {
        visibility: "hidden"
    }
})

export function Navbar({backUrl, closeUrl, invisible}) {
    const navigate = useNavigate()
    const classes = useStyles();
    return (
        <div className={`${classes.root} ${invisible ? classes.invisible : ""}`}>
            <div className={classes.back} onClick={() => navigate(backUrl)}>
                <img src={arrowIcon} />
            </div>
            <div className={classes.close} onClick={() => navigate(closeUrl)}>x</div>
        </div>
    )

}